import React, { useContext, useEffect, useState } from "react";
import { Form, Formik } from "formik";
import Button from "../common/Button";
import NewProjectContext from "../../contexts/NewProjectContext";
import { PAGE_STATE, langComponent } from "../../constants";
import AppContext from "../../AppContext";

import { ReactComponent as ArrowRightSvg } from "../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowLeftSvg } from "../../assets/icons/arrow-left.svg";

import { useLocation } from "react-router-dom";
import _ from "lodash";

const Info = () => {
  const { details, setDetails, goForward, goBackward } =
    useContext(NewProjectContext);
  const {
    getLang,
    designStyles: { workExchanges },
  } = useContext(AppContext);

  const Translation = getLang(langComponent.project);
  const TranslationCommon = getLang(langComponent.common);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  let location = useLocation();
  const [info, setInfo] = useState(
    details || {
      name: "",
      desc: "",
      program: "",
    }
  );

  useEffect(() => {
    setPageState(PAGE_STATE.IDLE);
    return () => {};
  }, [details]);

  // * Handle form validate
  const handleValidate = ({ name, program, renderer }) => {
    let errors = {};

    if (!name) errors.name = Translation("Please name your project");
    if (!program)
      errors.program = Translation("Please select the program used");

    return errors;
  };

  const handleSubmitInfo = (values) => {
    // const data = { ...values, type: selectedType };
    // setDetails((curr) => ({ ...curr, ...data }));
    goForward();
  };

  if (pageState !== PAGE_STATE.IDLE) {
    return <h1>Loading...</h1>;
  }
  const handleGoBack = () => {
    location.state = {};
    goBackward();
  };
  return (
    <Formik
      initialValues={details}
      validate={handleValidate}
      onSubmit={handleSubmitInfo}
      enableReinitialize={true}
    >
      <Form className="new-project-info">
        <h1 className="new-project__heading1">
          {Translation("Share My Project")}
        </h1>
        <h3 className="new-project__heading3">{Translation("Information")}</h3>

        {/*<TextArea*/}
        {/*  name="desc"*/}
        {/*  placeholder={Translation("Description preview")}*/}
        {/*  style={{ gridColumn: "1 / 3" }}*/}
        {/*></TextArea>*/}

        {/*<h3 className="new-project__heading3">{Translation("Type")}</h3>*/}

        <div className="new-project-cta" style={{ gridColumn: "1 / 3" }}>
          <Button
            label={TranslationCommon("Return")}
            variant={"secondary"}
            leadingIcon={<ArrowLeftSvg />}
            onClick={() => handleGoBack()}
          />
          <Button
            label={TranslationCommon("Next")}
            type="submit"
            trailingIcon={<ArrowRightSvg />}
          />
        </div>
      </Form>
    </Formik>
  );
};

Info.propTypes = {};

export default Info;
